import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';
import { scriptTypes } from 'constants/scripts';
import { styleMethods } from 'dataviz/config/map';
import { getProductSummaryForZone } from 'scripts/zones/productApplication-selectors';
import ZoneCollectionLayer from './ZoneCollectionLayer';
import { convertForLocale } from 'util/unitConversion';
import { getProductRateUnitTypeByScriptType } from 'util/unit';
import { getFormatFromZones } from 'products/selectors';
import { getCropBasedMessage, getMessage } from 'util/locale';
const baseString = 'vra-manage-layer';
const classString = classNames({
  [`${baseString}`]: true
});

const ManageLayer = ({
  cropNominalWeight,
  map,
  productValidationValues,
  script,
  scriptType
}) => {
  const cropId = useSelector(getActiveCropId);
  const noneEnteredLabel = getCropBasedMessage({ key: 'text__none-entered', cropId });
  const _onEachFeature = (zone, layer) => {
    const { product, rate, 'target-yield': targetYield } = getProductSummaryForZone({ scriptType, zone });

    const brand = get(product, 'brand');
    const name = get(product, 'name');
    const format = getFormatFromZones([zone]);
    const rateUnitType = getProductRateUnitTypeByScriptType({scriptType, format});
    const localizedRate = convertForLocale({ quantity: rate.q, unit: rate.u, unitType: rateUnitType });
    // If it's a fertility script, targetYield is undefined
    const localizedTargetYield = targetYield
    && convertForLocale({
      quantity: targetYield.q,
      unit: targetYield.u,
      unitType: 'area-density.yield',
      cropNominalWeight: cropNominalWeight
    });

    let productName;
    if (scriptType === scriptTypes.PLANTING) {
      productName = brand && name ? `${brand} ${name}` : noneEnteredLabel;
    } else {
      productName = name || noneEnteredLabel;
    }

    let popup = document.createElement('section');
    popup.class = 'vra-rx-layer__popup';
    const popupContent = document.createTextNode(
      scriptType === scriptTypes.PLANTING || scriptType === scriptTypes.APPLICATION
        ? getCropBasedMessage({
          key: `tooltip-text__zone-summary--${scriptType}`,
          cropId,
          params: {
            productName,
            rateValue: localizedRate.toString(),
            targetYieldValue: localizedTargetYield && localizedTargetYield.toString()
          }
        })
        : getMessage(
          `tooltip-text__zone-summary--${scriptType}`, {
            productName,
            rateValue: localizedRate.toString(),
            targetYieldValue: localizedTargetYield && localizedTargetYield.toString()
          }
        )
    );
    popup.appendChild(popupContent);
    layer.bindPopup(popup);
    layer.on('click', function(e) {
      layer.openPopup(e.latlng);
    });
  };
  const styleMethod = (scriptType === scriptTypes.FERTILITY || scriptType === scriptTypes.APPLICATION)
    ? styleMethods.fertilizerRate
    : styleMethods.seedRate;

  return script ? (
    <section className={classString}>
      <ZoneCollectionLayer
        layerName={`rx-${script.id}`} // help out with diffing
        map={map}
        onClickZone={()=>{}}
        onEachFeature={_onEachFeature}
        styleFunction={styleMethod.bind(null, script, productValidationValues )}
        zones={script.zones}
      />
    </section>
  ) : null;
};

ManageLayer.propTypes = {
  cropNominalWeight: propTypes.number,
  map: propTypes.object, // Inserted by mapping/leaflet.
  productValidationValues: propTypes.object.isRequired,
  script: propTypes.object.isRequired,
  scriptType: propTypes.string.isRequired
};
export default ManageLayer;
